$(() => {
    $('[data-dropdown]').each(function () {
        new Dropdown($(this))
    })
})

class Dropdown {
    constructor($elem) {
        this.$elem = $elem;
        this.init();
        this.triggers();
        this.events();
    }

    init() {
        this.$btn = this.$elem.find('.dropdown-toggle');
        this.$menu = this.$elem.find('dropdown-menu');
    }

    triggers() {
        // open dropdown
        this.$elem.on('dropdown:open', (e) => {
            this.open();
        })

        // close dropdown
        this.$elem.on('dropdown:close', (e) => {
            this.close();
        })

        // toggle dropdown
        this.$elem.on('dropdown:toggle', (e) => {
            this.toggle();
        })
    }

    events() {
        this.$btn.on('click', (e) => {
            event.preventDefault();
            this.$btn.trigger('dropdown:toggle');
        })
    }

    // open
    open() {
        this.$elem.addClass('is-active');
        this.$btn.attr('aria-expanded', true);
    }

    // close
    close() {
        this.$elem.removeClass('is-active');
        this.$btn.attr('aria-expanded', false);
    }

    // toggle
    toggle() {
        if (this.$btn.attr('aria-expanded') === 'false') {
            this.open();
        } else {
            this.close();
        }
    }
}